export function safeJSONParse(raw, fallback = null) {
    if (typeof raw !== 'string' || raw === '') {
        return fallback;
    }

    try {
        return JSON.parse(raw);
    } catch (e) {
        return fallback;
    }
}

export function readLocalStorageJSON(key, fallback = null) {
    try {
        return safeJSONParse(window.localStorage.getItem(key), fallback);
    } catch (e) {
        return fallback;
    }
}

export function readSessionStorageJSON(key, fallback = null) {
    try {
        return safeJSONParse(window.sessionStorage.getItem(key), fallback);
    } catch (e) {
        return fallback;
    }
}
